import { useEffect } from "react";

import { MARKETING_URL } from "safety/constants";

/**
 * Catch-all for every non-token route: bounce visitors to the marketing site
 * so the bare `safety.miter.com` domain is safe if someone hits it directly.
 */
const RedirectToMarketing = (): null => {
  useEffect(() => {
    // replace() so the redirect doesn't add a history entry the user can "back" into.
    window.location.replace(MARKETING_URL);
  }, []);

  return null;
};

export default RedirectToMarketing;
